import { takeLatest, call, put } from 'redux-saga/effects';
import {
  fetchPaymentsCreditsSuccess,
  fetchPaymentsCreditsFailure,
  updatePaymentsEmailsSuccess,
  updatePaymentsEmailsFailure,
  fetchPurchasesSuccess,
  fetchPurchasesFailure,
  fetchAllPurchasesSuccess,
  fetchAllPurchasesFailure,
  payPalPaySuccess,
  payPalPayFailure,
  fetchDenominationsSuccess,
  fetchDenominationsFailure,
  fetchAutomaticPaymentSuccess,
  fetchAutomaticPaymentFailure,
  editAutomaticRechargeSuccess,
  editAutomaticRechargeFailure,
  saveAutomaticRechargeSuccess,
  saveAutomaticRechargeFailure,
  creditRechargeSuccess,
  creditRechargeFailure,
  removeAutomaticRechargeSuccess,
  removeAutomaticRechargeFailure,
  fetchAutomaticPaymentRequest,
} from './actions';
import {
  FETCH_PAYMENTS_CREDITS_REQUEST,
  UPDATE_PAYMENTS_EMAILS_REQUEST,
  FETCH_PURCHASES_REQUEST,
  FETCH_ALL_PURCHASES_REQUEST,
  PAYPAL_PAY_REQUEST,
  FETCH_DENOMINATIONS_REQUEST,
  SAVE_AUTOMATIC_RECHARGE_REQUEST,
  FETCH_AUTOMATIC_PAYMENT_REQUEST,
  EDIT_AUTOMATIC_RECHARGE_REQUEST,
  CREDIT_RECHARGE_REQUEST,
  REMOVE_AUTOMATIC_RECHARGE_REQUEST,
} from './types';
import api from '../api';
import { checkApiResponse, checkApiError } from '../rootSaga';

function* fetchPaymentsCredits() {
  try {
    const res = yield call(api.payments.getPaymentsCredits);
    yield call(checkApiResponse, res);
    yield put(fetchPaymentsCreditsSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchPaymentsCreditsFailure(error));
  }
}

function* updatePaymentsEmail(action) {
  try {
    const res = yield call(api.payments.updatePaymentsEmail, action.params);
    yield call(checkApiResponse, res);
    yield put(updatePaymentsEmailsSuccess(res.data, res.status));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(updatePaymentsEmailsFailure(error));
  }
}

export function* fetchPurchases(action) {
  try {
    const res = yield call(api.payments.getPurchases, action.payload);
    yield call(checkApiResponse, res);
    yield put(
      fetchPurchasesSuccess(
        {
          purchases: res.data.data,
          page: action.payload.page,
          total: res.data.count,
        },
        res.status
      )
    );
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchPurchasesFailure(error));
  }
}

export function* fetchAllPurchases(action) {
  try {
    const res = yield call(api.payments.getPurchases, action.payload);
    yield call(checkApiResponse, res);
    yield put(fetchAllPurchasesSuccess(res.data.data, res.status));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchAllPurchasesFailure(error));
  }
}

function* payPalPayment(action) {
  try {
    const res = yield call(api.payments.pay, action.payment);
    yield call(checkApiResponse, res);
    yield put(payPalPaySuccess(res.data.paypalUrl, res.status));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(payPalPayFailure(error));
  }
}

function* fetchDenominations() {
  try {
    const res = yield call(api.payments.getDenominations);
    yield call(checkApiResponse, res);
    yield put(fetchDenominationsSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchDenominationsFailure(error));
  }
}

function* saveAutomaticRecharge(action) {
  try {
    const res = yield call(api.payments.saveAutomaticRecharge, action.payment);
    yield call(checkApiResponse, res);
    yield put(saveAutomaticRechargeSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveAutomaticRechargeFailure(error));
  }
}

function* fetchAutomaticPayment(action) {
  try {
    const res = yield call(api.payments.getAutomaticPayment, action.params);
    yield call(checkApiResponse, res);
    yield put(fetchAutomaticPaymentSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchAutomaticPaymentFailure(error));
  }
}

function* editAutomaticRecharge(action) {
  try {
    const res = yield call(api.payments.editAutomaticRecharge, action.params);
    yield call(checkApiResponse, res);
    yield put(editAutomaticRechargeSuccess());
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(editAutomaticRechargeFailure(error));
  }
}

function* removeAutomaticRecharge(action) {
  try {
    const res = yield call(api.payments.removeAutomaticRecharge, action.params);
    yield call(checkApiResponse, res);
    yield put(removeAutomaticRechargeSuccess());
    yield put(fetchAutomaticPaymentRequest(action.params));
  }
  catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(removeAutomaticRechargeFailure(error));
  }
}

function* rechargeCredit(action) {
  try {
    const res = yield call(api.payments.rechargeCredit, action.params);
    yield call(checkApiResponse, res);
    yield put(creditRechargeSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(creditRechargeFailure(error));
  }
}

export default function* rootSaga() {
  yield takeLatest(FETCH_PAYMENTS_CREDITS_REQUEST, fetchPaymentsCredits);
  yield takeLatest(UPDATE_PAYMENTS_EMAILS_REQUEST, updatePaymentsEmail);
  yield takeLatest(FETCH_PURCHASES_REQUEST, fetchPurchases);
  yield takeLatest(FETCH_ALL_PURCHASES_REQUEST, fetchAllPurchases);
  yield takeLatest(PAYPAL_PAY_REQUEST, payPalPayment);
  yield takeLatest(FETCH_DENOMINATIONS_REQUEST, fetchDenominations);
  yield takeLatest(SAVE_AUTOMATIC_RECHARGE_REQUEST, saveAutomaticRecharge);
  yield takeLatest(FETCH_AUTOMATIC_PAYMENT_REQUEST, fetchAutomaticPayment);
  yield takeLatest(EDIT_AUTOMATIC_RECHARGE_REQUEST, editAutomaticRecharge);
  yield takeLatest(REMOVE_AUTOMATIC_RECHARGE_REQUEST, removeAutomaticRecharge);
  yield takeLatest(CREDIT_RECHARGE_REQUEST, rechargeCredit);
}
